// src/componenti/PageContent.js
import React from 'react';
import { Stack, Typography } from '@mui/material';

export default function PageContent({ title, children }) {
  return (
    // Usiamo Stack come contenitore principale
    <Stack
      spacing={5} // <-- Applica 40px di spazio TRA ogni figlio diretto
      sx={{
        py: 1, // Padding verticale generale della pagina
      }}
    >
      {title &&
        <Typography variant="h4" component="h2" align="center">
          {title}
        </Typography>
      }

      {/* I figli (il contenuto della pagina) verranno renderizzati qui */}
      {children}
    </Stack>
  );
}